/**
 * Calculate the start date of a quarter
 * @param year Year of the quarter
 * @param quarter Quarter (1..4)
 * @returns {string} Start of the quarter in YYYY-MM-DD
 */
export default function(year, quarter)
{
    switch (quarter)
    {
        case 1:
            return year + '-01-01';
        case 2:
            return year + '-04-01';
        case 3:
            return year + '-07-01';
        case 4:
            return year + '-10-01';
    }
}